import { generateNpcPersonality, type NpcPersonality } from "../social/personality.js";
import type { SettlementResidentV1 } from "./production.js";

/** V1 baseline for applicants AND accepted residents, including older saves.
 * Beacon scope distinguishes the repeated founder ids. Profession, rank,
 * assignment, offer epoch, and mood are not new seed inputs: accepting or
 * promoting a resident must not change the person previewed in recruitment.
 * Keep this adapter pinned to the immutable V1 recipe when adding versions. */
export function settlementResidentPersonality(
  beaconId: string, resident: Pick<SettlementResidentV1, "id" | "trait">,
): NpcPersonality {
  return generateNpcPersonality({ identity: ["settlement", beaconId, resident.id],
    traits: resident.trait ? [resident.trait] : [] });
}
